export interface Task {
  id: string;
  activityTypeId: string;
  title: string;
  completedAt: string | null;
  focusedDate: string | null;
  prioritizedDate: string | null;
  displayOrder: number;
  createdAt: string;
  recurrenceType: 'DAILY' | 'WEEKLY' | 'MONTHLY' | null;
  recurrenceDays: string | null;
  parentTaskId: string | null;
  instanceDate: string | null;
  openItemCount?: number | null;
  totalItemCount?: number | null;
}

export interface CreateTaskRequest {
  activityTypeId: string;
  title: string;
  recurrenceType?: 'DAILY' | 'WEEKLY' | 'MONTHLY';
  recurrenceDays?: string;
  recurrenceInterval?: number;
  recurrenceEndDate?: string;
}

export function isRecurring(task: Task): boolean {
  return task.parentTaskId !== null;
}
